import Vue from "vue";

// const directive = {
//   trigger: 'click',
//   inserted: function (el) {
//     el.parentNode.insertBefore(this.a, el.nextSibling)
//   },
//   bind: function () {
//     let a = document.createElement('a');
//     a.innerText = 'X';
//     a.className = 'cs-clearable';

//     this.handler = function () {
//       el.value = '';
//     }.bind(this)

//     a.addEventListener('click', this.handler);

//   },
//   unbind: function () {
//     this.a.removeEventListener('click', this.handler)
//   }
// }

Vue.directive("clearable", {
  inserted: function(el, self, vnode) {
    const c = vnode.context;
    el.parentNode.insertBefore(c.a, el.nextSibling);
  },
  bind: function(el, self, vnode) {
    const c = vnode.context;
    const a = document.createElement("a");
    const i = document.createElement("i");
    a.className = "cs-clearable";
    i.className = "cs-delete";
    a.appendChild(i);

    c.clickHandler = function(e) {
      el.value = "";
      this.a.style.display = "none";

      vnode.elm.dispatchEvent(new CustomEvent("clear"));
      this.$emit('clear');
    }.bind(c);

    c.inputHandler = function(el) {
      this.a.style.display = el.target.value ? "initial" : "none";
    }.bind(c);

    el.addEventListener("input", c.inputHandler);
    a.addEventListener("click", c.clickHandler);

    a.style.display = el.value ? "initial" : "none";
    c.a = a;
  },
  unbind: function(el, self, vnode) {
    const c = vnode.context;
    el.removeEventListener("click", c.inputHandler);
    c.a.removeEventListener("click", c.clickHandler);
  }
});
